export const Challenge_Toasts_EN = {
  // Toasts used for challenges
  challengeToasts: {
    joined: "You have joined",
    request: "Request to join is pending",
    error: "Something went wrong trying to join challenge",
    errorPlatform:
      "Could not join challenge, make sure you are connected to the correct platform for this game",
    notFound: "Could not find challenge to join",
    addAccount: "Add account",
  },
};
